import Entity from "../../../class/abstract/Entity";

class LegalData extends Entity {
    socialReason = null;
    siret = null;
    ape = null;
    tvaIntra = null;
    legalStatus = null;
    companyRegister = null;
    bankName = null;
    iban = null;
    bic = null;
    refMandat = null;
    dateMandat = null;

    constructor(datas = {}) {
        super(datas);

        this.setAttributes(datas);
    }

    setAttributes(datas) {
        let keys = Object.keys(this);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined) {
                Reflect.set(this, key, datas[key]);
            }
        }
    }
}

export default LegalData;
